import React, { useState, useEffect, useRef } from "react";
import "./navbar.css";
import { FaBars, FaCartPlus } from "react-icons/fa";
import { MyGlobalContext } from "../../Context";
import { Link, NavLink, useLocation } from "react-router-dom";
import cocktail from "../../images/cocktail.png";

const Navbar = () => {
  const location = useLocation();
  const {
    totalItem,
    token,
    isCheckDetails,
    isPaymentTrue,
    path,
    setPath,
    runPath,
    toggleRunPath,
  } = MyGlobalContext();
  // console.log(path);
  // const lengthOfProduct = myState.length;
  const [isTrue, setNavIsTrue] = useState(false);
  const ToggleFaBars = () => {
    setNavIsTrue((previous) => !previous);
  };
  

  // this useEffect for update update the path state;
  useEffect(() => {
    setPath(location.pathname);
  }, [runPath]);
  const ContainerDiv = useRef(null);
  const linksUl = useRef(null);
  useEffect(() => {
    let LinksHeight;
    if (path === "/profile") {
      LinksHeight = linksUl.current.getBoundingClientRect().height + 100;
    } else {
      LinksHeight = linksUl.current.getBoundingClientRect().height + 10;
    }

    // console.log(LinksHeight);
    if (isTrue) {
      ContainerDiv.current.style.height = `${LinksHeight}px`;
    } else {
      ContainerDiv.current.style.height = "0px";
    }
  }, [isTrue, path]);
  return (
    <nav
      className={`${isCheckDetails ? "relative" : ""} ${
        isPaymentTrue && "relative"
      }`}
    >
      <div className="nav-header">
        <Link
          className="nav-link-logo"
          onClick={() => {
            toggleRunPath();
            setNavIsTrue(false);
          }}
          to="/"
        >
          <img src={cocktail} alt="" className="nav-logo-cocktail" />
        </Link>
        <button onClick={ToggleFaBars} className="nav-fa-btn">
          <FaBars />
        </button>
      </div>
      <div className="height-container-links" ref={ContainerDiv}>
        <ul
          onClick={() => {
            toggleRunPath();
            setNavIsTrue(false);
          }}
          ref={linksUl} className="ul-nav"
        >
          <li>
            <NavLink to="/" className="link-btn-class">
              Home
            </NavLink>
          </li>
          {token.length !== 0 && (
            <li>
              <NavLink to="/profile" className="link-btn-class">
                Profile
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to="/about" className="link-btn-class">
              About
            </NavLink>
          </li>
          {token.length === 0 && (
            <li>
              <NavLink to="/login" className="link-btn-class">
                Login
              </NavLink>
            </li>
          )}
          <li className="cart-li">
            <NavLink to="/cart" className="link-btn-class fa-cart">
              <FaCartPlus className="fa-cart-icon" />
              <span className="li-cart-span">{totalItem}</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
